let config = {}
    switch (document.location.host) {
        case 'wayfinding.orchestr8.ai' :
           config = import('./config/wayfinding.orchestr8.ai.js');
           break;
        default :
            config = import('./config/wayfinding.orchestr8.ai.js');
            break;

    }

export default config;



// WEBPACK FOOTER //
// ./src/configLoader.js